import useChatPage from "./hooks/useChatPage";
import MessageList from "./MessageList";
import MessageComposer from "./MessageComposer";
import styles from "./chatPage.module.css";

const ChatPage = () => {
  const {
    messages,
    dialogStatus,
    onSubmit,
    onCreateDialog,
    creatingDialog,
    waiting,
    followUps,
    score,
  } = useChatPage();

  return (
    <div className={styles.chatPage}>
      <MessageList {...{ messages, score, waiting }} />
      <MessageComposer
        {...{
          onSubmit,
          onCreateDialog,
          creatingDialog,
          dialogStatus,
          waiting,
          followUps,
        }}
      />
    </div>
  );
};

export default ChatPage;
